const CLIENT_ID_KEY = 'pp.clientId';
const NAME_KEY = 'pp.name';
const SPECTATOR_KEY = 'pp.spectator';

/** localStorage throws in private-mode Safari and in sandboxed iframes. */
const safeGet = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* ignore — the session still works, it just won't survive a reload */
  }
};

const randomId = (): string => {
  // randomUUID needs a secure context; fall back to raw random bytes on plain HTTP.
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

/**
 * A stable per-browser id. Reconnecting with the same id reclaims your seat,
 * your vote and your host role after a reload or a dropped connection.
 */
export const getClientId = (): string => {
  const existing = safeGet(CLIENT_ID_KEY);
  if (existing) return existing;
  const created = randomId();
  safeSet(CLIENT_ID_KEY, created);
  return created;
};

export const getStoredName = (): string => safeGet(NAME_KEY) ?? '';
export const storeName = (name: string): void => safeSet(NAME_KEY, name);

export const getStoredSpectator = (): boolean => safeGet(SPECTATOR_KEY) === 'true';
export const storeSpectator = (spectator: boolean): void =>
  safeSet(SPECTATOR_KEY, String(spectator));
